import { BRAND_ALTERNATE_PAYMENT_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[BRAND_ALTERNATE_PAYMENT_FORM_MODULE_ID]: {
		moduleType: 'misc',
		miscModuleType: 'linkPaymentModule',
	},
}
